import _logoBeta from './logo_satellite_primary_white_beta.png';
import _logoStackedBeta from './logo_satellite_primary_white_stacked_beta.png';
import _logo from './logo_sedaro_primary_white.png';
import _logoStacked from './logo_sedaro_primary_white_stacked.png';
// import { IS_CES } from 'config';
const IS_CES = true; // Force non-beta logos

export const logo = !IS_CES ? _logoBeta : _logo;
export const logoStacked = !IS_CES ? _logoStackedBeta : _logoStacked;
